import React, { lazy, Suspense } from "react";
import { Routes, Route } from "react-router-dom";
import FullPageLoader from "src/components/loaders/PageLoader";
import DashboardLayout from "src/layout/DashboardLayout";
import ProtectedRoute from "src/auth/protected-route/ProtectedRoute";


const RouteComponent = () => {
  return (
    <Suspense fallback={<FullPageLoader />}>
      <Routes>
        {route.map((route, index) => {  
          const Component = route.components;
          const Layout = route.layout || React.Fragment;

          return (
            <Route
              key={index}
              path={route.path} 
              element={
  route.protected ? (
    <ProtectedRoute>
      <Layout>
        <Component />
      </Layout>
    </ProtectedRoute>
  ) : (
    <Layout>
      <Component />
    </Layout>
  )
}
            />
          );
        })}
      </Routes>
    </Suspense>
  );
};

  const route = [
  {
    path: "/",
    components: lazy(() => import("src/views/pages/not-found/NotFound")),
  },
  {
    path: "/portal",
    components: lazy(() => import("src/auth/contract-login/ContractLogin")),
  },
  // {
  //   path: "/contract-login",
  //   components: lazy(() => import("src/auth/contract-login/ContractLogin")),
  // },
  {
    path: "/login",
    components: lazy(() => import("src/auth/signin/Login")),

  },
//   {
//     path: "/register",
//     components: lazy(() => import("src/auth/signup/Register")),
//   },
//   {
//     path: "/forgot-password",
//     components: lazy(() => import("src/auth/forgotPassword/ForgotPassword")),
//   },
  {
    path: "/dashboard",
    components: lazy(() => import("src/views/pages/dashboard/Dashboard")),
    layout: DashboardLayout,
    protected: true,
  },
  {
    path: "/accounts/accounts-overview",
    components: lazy(() => import("src/views/pages/accounts/accounts-overview/AccountsOverview")),
    layout: DashboardLayout,
  },
  {
    path: "/cards/cards-overview",
    components: lazy(() => import("src/views/pages/cards/card-overview/CardsOverview")),
    layout: DashboardLayout,
  },
  {
    path: "/payments/transfer-money",
    components: lazy(() => import("src/views/pages/payments/transfer-money/TransferMoney")),
    layout: DashboardLayout,
  },
  {
    path: "/documents/bank-documents",
    components: lazy(() => import("src/views/pages/documents/bank-documents/BankDocuments")),
    layout: DashboardLayout,
  },
  {
    path: "/accounts/accounts-transaction",
    components: lazy(() => import("src/views/pages/accounts/accounts-transaction/AccountsTransaction")),
    layout: DashboardLayout,
  },
  {
    path: "/accounts/accounts-information",
    components: lazy(() => import("src/views/pages/accounts/accounts-information/AccountsInformation")),
    layout: DashboardLayout,
  },
  {
    path: "/accounts/balance-forecast",
    components: lazy(() => import("src/views/pages/accounts/balance-forecast/BalanceForecast")),
    layout: DashboardLayout,
  },
  {
    path: "/payments/exchange-money",
    components: lazy(() => import("src/views/pages/dashboard/shortcuts/ExchangeMoney")),
    layout: DashboardLayout,
  },
  {
    path: "/payments/send-money",
    components: lazy(() => import("src/views/pages/dashboard/shortcuts/SendMoney")),
    layout: DashboardLayout,
  },
  {
    path: "/payments/wire-transfer",
    components: lazy(() => import("src/views/pages/dashboard/shortcuts/WireTransfer")),
    layout: DashboardLayout,
  },
  {
    path: "/payments/transaction-report",
    components: lazy(() => import("src/views/pages/dashboard/shortcuts/TransactionReport")),
    layout: DashboardLayout,
  },
  {
    path: "/privacy-and-security",
    components: lazy(() => import("src/components/privacy-security/PrivacySecurity")),
    
  },

//   {
//     path: "/accounts",
//     components: lazy(() => import("src/views/accounts/Accounts")),
//     layout: layout,
//   },
//   {
//     path: "/transactions",
//     components: lazy(() => import("src/views/transactions/Transactions")),
//     layout: layout,
//   },
//   {
//     path: "/beneficiaries",
//     components: lazy(() => import("src/views/beneficiaries/Beneficiaries")),
//     layout: layout,
//   },
//   {
//     path: "/send-money",
//     components: lazy(() => import("src/views/payments/SendMoney")),
//     layout: layout,
//   },
//   {
//     path: "/wire-transfer",
//     components: lazy(() => import("src/views/payments/WireTransfer")),
//     layout: layout,
//   },
//   {
//     path: "/exchange-money",
//     components: lazy(() => import("src/views/payments/ExchangeMoney")),
//     layout: layout,
//   },
//   {
//     path: "/payment-request",
//     components: lazy(() => import("src/views/payment/NewRequest")),
//     layout: layout,
//   },
//   {
//     path: "/all-request",
//     components: lazy(() => import("src/views/payment/AllRequest")),
//     layout: layout,
//   },
//   {
//     path: "/cards",
//     components: lazy(() => import("src/views/cards/Cards")),
//     layout: layout,
//   },
//   {
//     path: "/loans",
//     components: lazy(() => import("src/views/loans/Loans")),
//     layout: layout,
//   },
//   {
//     path: "/investments",
//     components: lazy(() => import("src/views/investments/Investments")),
//     layout: layout,
//   },
//   {
//     path: "/notifications",
//     components: lazy(() => import("src/views/notifications/Notifications")),
//     layout: layout,
//   },
//   {
//     path: "/profile",
//     components: lazy(() => import("src/views/profile/Profile")),
//     layout: layout,
//   },
//   {
//     path: "/settings",
//     components: lazy(() => import("src/views/profile/ProfileSettings")),
//     layout: layout,
//   },
];

export default RouteComponent;